export default {
  TRASH: 'Éléments supprimés',
  SEND: 'Éléments envoyés',
  DRAFT: 'Brouillons',
  INBOX: 'INBOX',
}
